export enum IncomeTypes {
    'W-2' = 'W2-earner',
    'Self Employment' = 'W2-earner'
}

export enum Citizenship {
    'US Citizen' = 'USCitizen',
    'Permanent Resident' = 'PermanentResident',
    'Non-Perm Resident' = 'NonpermanentResident',
    'Non-Resident Alien' = 'ForeignNational'
}
